import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { logoutAction } from "@monorepo/slices/auth";

export const useLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logout = () => {
    dispatch(logoutAction());
    history?.push(routeConfig.login.self);
  };

  return { logout };
};
